export default "__VITE_ASSET__DkRwbzRr__"